"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MONETARY_AMOUNT_REGEX = /^\d+(\.\d{0,2})?$/;
exports.Validator = {
    name: "monetary_amount",
    errorMessage: "Field should be a non-negative decimal number with max. 2 fractional digits.",
    validate: function (value) { return MONETARY_AMOUNT_REGEX.test("" + value); },
};
